import React, { useState } from 'react';
import './Contact.css';
import authorPic from '../assets/author.jpg';
import authorVideo from '../assets/newVideo.mov';
import { FaLinkedinIn, FaInstagram, FaYoutube, FaPhone } from 'react-icons/fa';

const contactDetails = [
    {
        icon: <FaLinkedinIn />,
        label: 'LinkedIn',
        info: 'https://www.linkedin.com/in/hasna-h’art-élégance-ba5325387?utm_source=share_via&utm_content=profile&utm_medium=member_ios',
        type: 'link'
    },
    {
        icon: <FaInstagram />,
        label: 'Instagram',
        info: 'https://www.instagram.com/hart_elegance_?igsh=MWkxODk3aDJnZ2Y2dA%3D%3D&utm_source=qr',
        type: 'link'
    },
    {
        icon: <FaYoutube />,
        label: 'YouTube',
        info: 'https://youtube.com/@hartelegance?si=xgqnFc3hc19p3rJz',
        type: 'link'
    }
    , {
        icon: <FaPhone />,
        label: 'Téléphone',
        info: '+33 7 49 66 03 29',
        type: 'phone'
    }
];

const Contact = () => {
    const [selected, setSelected] = useState(null);
    const [formStatus, setFormStatus] = useState('idle');

    const isMobile = () => {
        if (typeof navigator === 'undefined') return false;
        return /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
    };

    const handleContactClick = (item, idx, e) => {
        if (item.type === 'phone') {
            if (isMobile()) {
                // let the anchor handle tel: behavior
                return;
            }
            // prevent default anchor behavior on desktop and toggle display
            e.preventDefault();
            setSelected(selected === idx ? null : idx);
            return;
        }
        // links open directly
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setFormStatus('submitting');

        const formData = new FormData(e.target);

        try {
            const response = await fetch('https://formsubmit.co/ajax/h.mour11.11@gmail.com', {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                setFormStatus('success');
                e.target.reset();
            } else {
                setFormStatus('error');
            }
        } catch (error) {
            setFormStatus('error');
        }
    };

    return (
        <div className="bio-contact-bg">
            <div className="bio-contact-main">
                <div className="bio-contact-pic-row">
                    <div className="bio-author-pic-large">
                        <img src={authorPic} alt="Hasna, Fondatrice" />
                    </div>
                </div>
                <div className="bio-contact-sections">
                    <div className="bio-contact-bio-section">
                        <h1 className="bio-author-name">Demander un Entretien Stratégique Confidentiel</h1>
                        <div className="bio-author-bio" style={{ marginTop: '1.5rem' }}>
                            Toute entrée chez H'ART ÉLÉGANCE commence par un Entretien Stratégique Confidentiel. Cet espace permet de déposer une demande, de comprendre ce qui appelle une lecture et de déterminer l'orientation la plus juste au sein de la Maison. <br /><br />
                            H'ART ÉLÉGANCE ne répond pas à une logique de volume. Chaque demande est considérée avec exigence, discrétion et discernement. <br /><br />
                            Lors de cet entretien, Hasna observe ce qui se manifeste dans la présence, dans le corps, dans les lignes, dans les tensions, dans les silences et dans l'allure. Il ne s'agit ni de conseil en image, ni de coaching, ni de thérapie. Il s'agit d'une première lecture stratégique de l'être. <br /><br />
                            Si votre demande résonne avec l'univers de la Maison, vous pouvez entrer en relation par e-mail, téléphone ou formulaire confidentiel.
                        </div>
                        <div className="bio-video-container">
                            <video
                                className="bio-author-video"
                                controls
                                playsInline
                                preload="auto"
                                aria-label="Présentation vidéo de la Maison"
                            >
                                <source src={authorVideo} type="video/mp4" />
                                Votre navigateur ne supporte pas la lecture vidéo. Vous pouvez télécharger la vidéo <a href={authorVideo}>ici</a>.
                            </video>
                        </div>
                    </div>
                    <div className="bio-contact-contacts-section">
                        <h2 className="bio-contact-title">Formulaire Confidentiel</h2>

                        {formStatus === 'success' ? (
                            <div className="form-success-message" style={{ padding: '2.5rem', background: 'rgba(212, 175, 55, 0.05)', border: '1px solid rgba(212, 175, 55, 0.3)', borderRadius: '8px', color: '#fff', textAlign: 'center', marginBottom: '2rem', maxWidth: '100%' }}>
                                <h3 style={{ color: 'var(--gold, #d4af37)', marginBottom: '1rem', fontSize: '1.4rem', fontWeight: '400' }}>Demande envoyée avec succès</h3>
                                <p style={{ fontSize: '1rem', lineHeight: '1.6', color: 'rgba(255, 255, 255, 0.8)', marginBottom: '2rem' }}>
                                    Nous avons bien reçu votre demande d'Entretien Stratégique Confidentiel. <br />La Maison vous recontactera très prochainement.
                                </p>
                                <button className="cta-button" onClick={() => setFormStatus('idle')} style={{ fontSize: '0.85rem' }}>Faire une autre demande</button>
                            </div>
                        ) : (
                            <form className="confidential-form" onSubmit={handleFormSubmit}>
                                <input type="hidden" name="_subject" value="Nouvelle Demande d'Entretien Stratégique" />
                                <input type="hidden" name="_template" value="box" />
                                <input type="hidden" name="_language" value="fr" />
                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Votre nom</label>
                                        <input type="text" name="nom" required />
                                    </div>
                                    <div className="form-group">
                                        <label>Votre prénom</label>
                                        <input type="text" name="prenom" required />
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Votre adresse e-mail</label>
                                        <input type="email" name="email" required />
                                    </div>
                                    <div className="form-group">
                                        <label>Votre téléphone</label>
                                        <input type="tel" name="telephone" required />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Votre ville / région</label>
                                    <input type="text" name="ville" required />
                                </div>
                                <div className="form-group">
                                    <label>Ce qui appelle aujourd’hui votre démarche</label>
                                    <input type="text" name="objet" required />
                                </div>
                                <div className="form-group">
                                    <label>Votre message confidentiel</label>
                                    <textarea name="message" rows="5" required></textarea>
                                </div>

                                <div className="form-checkbox">
                                    <label>
                                        <input type="checkbox" name="consentement" required />
                                        <span>J’accepte que mes informations soient utilisées pour répondre à ma demande.</span>
                                    </label>
                                </div>

                                <button type="submit" className="cta-button form-submit" disabled={formStatus === 'submitting'}>
                                    {formStatus === 'submitting' ? 'Envoi en cours...' : 'Envoyer ma demande confidentielle'}
                                </button>
                                {formStatus === 'error' && (
                                    <p style={{ color: '#ff6b6b', marginTop: '1rem', fontSize: '0.9rem' }}>
                                        Une erreur est survenue lors de l'envoi. Veuillez réessayer plus tard.
                                    </p>
                                )}
                            </form>
                        )}

                        <div className="bio-contact-icons" style={{ marginTop: '3rem' }}>
                            {contactDetails.map((item, idx) => {
                                const href = item.type === 'link' ? item.info : (item.type === 'email' ? `mailto:${item.info}` : `tel:${item.info}`);
                                return (
                                    <a
                                        key={item.label}
                                        className="bio-contact-icon"
                                        href={href}
                                        target={item.type === 'link' ? '_blank' : undefined}
                                        rel={item.type === 'link' ? 'noopener noreferrer' : undefined}
                                        aria-label={item.label}
                                        onClick={(e) => handleContactClick(item, idx, e)}
                                    >
                                        {item.icon}
                                    </a>
                                );
                            })}
                        </div>
                        {selected !== null && contactDetails[selected].type === 'phone' && (
                            <div className="bio-contact-info-left">
                                <h3>{contactDetails[selected].label}</h3>
                                <div>{contactDetails[selected].info}</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
